'use strict';

String.prototype.toProperCase = function () {
    return this.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
};

// Polyfills - add as needed
// require('./polyfills/foreach.js');


// Script Modules
// Include as needed on your project. All scripts will be bundled together.
// Some sample files are included for ideas to get you started.

// require('./animations.js');
require('./hoverintent.js');
require('./menu.js');
require('./modals.js');
require('./upload.js');
require('./smooth-scroll.js');
require('./card.js');
require('./toggle.js');
require('./archive.js');
// require('./copyrights.js');
